<template>
  <div class="upload-multiple-image">
    <v-layout wrap fill-height>
      <v-flex
        class="pr-2 pb-3 pl-2"
        v-if="images.length < limit"
        style="cursor: pointer; height: 130px"
      >
        <div
          class="btn-upload"
          style="
            border-radius: 10px;
            border: 4px dashed #eee;
            display: inline-table;
            width: 100%;
            height: 100%;
            padding-top: 13px;
          "
          :style="errors && errors.length && 'border-color:red'"
          onclick="document.getElementById('photoUploadInputMultiple').click()"
          @dragover.prevent
          @drop.prevent="onFileChange($event)"
        >
          <v-responsive>
            <v-row column justify="center" fill-height align="center">
              <v-col v-if="!loading">
                <div
                  class="text-center"
                  style="color: #0c4d9d"
                  :style="errors && errors.length && 'color:red'"
                >
                  <v-icon :color="errors && errors.length ? 'red' : '#0c4d9d'" large
                    >camera_alt</v-icon
                  >
                  <br />เลือกไฟล์เพื่ออัพโหลด
                </div>
              </v-col>
              <v-col v-else class="text-center">
                <div class="text-center primary--text font-weight-bold">
                  กำลังอัปโหลดรูปภาพ กรุณารอสักครู่
                </div>
                <v-progress-circular indeterminate color="primary" size="30"></v-progress-circular>
              </v-col>
            </v-row>
          </v-responsive>
        </div>
      </v-flex>
    </v-layout>

    <div class="form-control has-error" v-if="isAlert">
      <span class="text-error">{{ "Please try to upload file again" }}</span>
    </div>
    <input
      type="file"
      :multiple="multiple"
      class="form-control-file pt-2"
      name="photoUpload"
      id="photoUploadInputMultiple"
      data-vv-as="File"
      accept="image/*;capture=camera"
      @change="onFileChange($event)"
      style="
        overflow: hidden;
        position: fixed;
        width: 1px;
        height: 1px;
        z-index: -1;
        opacity: 0;
      "
    />
    <div>
      <v-row>
        <v-col
          @mouseover="hover = k"
          @mouseleave="hover = ''"
          v-for="(item, k) in value"
          :key="k"
          cols="3"
          class="pr-1"
        >
          <div style="position: relative">
            <v-img
              @click="showPreview(item)"
              style="border-radius: 6px"
              aspect-ratio="1"
              :src="item"
              @error="() => (item = null)"
            >
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular indeterminate color="grey"></v-progress-circular>
                </v-row>
              </template>
            </v-img>
            <div style="position: absolute; right: -5px; top: -5px; z-index: 1">
              <v-btn @click.stop="deleteImg(k)" x-small fab color="primary"
                ><v-icon small>close</v-icon></v-btn
              >
            </div>
          </div>
        </v-col>
      </v-row>
    </div>
    <v-dialog width="550px" v-model="previewDialog" persistent>
      <v-card v-if="previewDialog">
        <div class="text-right">
          <v-btn @click="previewDialog = false" icon><v-icon>close</v-icon></v-btn>
        </div>
        <v-img :src="currentImg"></v-img>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import UpdateMultipleFileMixin from "./UpdateMultipleFileMixin.js";
export default {
  mixins: [UpdateMultipleFileMixin],
  data() {
    return {
      previewDialog: false,
      currentImg: "",
    };
  },
  methods: {
    showPreview(item) {
      this.currentImg = item;
      this.previewDialog = true;
    },
  },
};
</script>

<style scoped lang="scss">
.btn-upload {
  &:hover {
    background: rgba(0, 0, 0, 0.05);
  }
}
</style>
